import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { NotFound } from '../NotFound/NotFound.js';
import { renderCarouselBlocks } from './renderCarouselBlocks.js';
import { renderGridBlocks } from './renderGridBlocks.js';
export const FilteredBlocks = JSX(({ blocksSection, blocksToRender = [], notFound, ...rest }) => {
    switch (blocksSection?.view) {
        case 'grid':
            return (_jsxs("div", { children: [renderNotFound(notFound, blocksToRender), renderGridBlocks({ ...blocksSection, ...rest, blocksToRender })] }));
        case 'carousel':
            return (_jsxs("div", { className: "relative", children: [renderNotFound(notFound, blocksToRender), renderCarouselBlocks({ ...rest, blocksToRender })] }));
        default:
            return null;
    }
});
const renderNotFound = (notFound, blocksToRender) => notFound && !blocksToRender.length ? _jsx(NotFound, { ...notFound }) : null;
//# sourceMappingURL=FilteredBlocks.js.map